import React from 'react';
import { View } from 'react-native';

//= ========================================================================

const BreakLine = ({ marginTop = 0, marginBottom = 30 }) => (
  <View
    style={{
      height: 1,
      backgroundColor: '#e2e8f0',
      marginTop,
      marginBottom,
    }}
  />
);
export default BreakLine;
